import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.851 4.353a1.204 1.204 0 00-1.702 0l-6.796 6.796c-.47.47-.47 1.232 0 1.702l6.796 6.796c.47.47 1.232.47 1.702 0l6.796-6.796c.47-.47.47-1.232 0-1.702l-6.796-6.796zm1.414-1.415l6.797 6.797a3.204 3.204 0 010 4.53l-6.797 6.797a3.204 3.204 0 01-4.53 0l-6.797-6.797a3.204 3.204 0 010-4.53l6.797-6.797a3.204 3.204 0 014.53 0zM12.585 10L14 8.586l3.419 3.418L14 15.423l-1.414-1.414 2.004-2.005L12.586 10zm-4 0L10 8.586l3.419 3.418L10 15.423l-1.414-1.414 2.004-2.005L8.586 10z"
    />
  </svg>
);
